<template>
    <div>
        <div class="row grey tabel" style="width: 100%; margin-top: 15px; padding-top: 5px;">
            <div class="col s1">
                {{$t('devices.pest')}}
            </div>
            <div class="col s3">
                <itemorgroupselector
                    :pestsgroups="pests"
                    v-bind:pest_id.sync="pest_thresold.pest_id"
                    v-bind:group_id.sync="pest_thresold.group_id" :disabled="disabled"
                    v-on:changed="pests_changed(pest_thresold)" />
            </div>
            <div class="col s3">
                <modal :question="$t('place.remove_target_pest_question')" :confirmText="$t('menu.buttons.delete')" :identifier="uid" v-on:onConfirm="removeMe()" />
            </div>
        </div>
        <div class="row grey" style="width: 100%;  ">
            <div class="col s2">
                 {{$t('devices.no_activity')}} ({{$t('routine_analyses.zero_points')}})
            </div>
            <div class="col s2">
                 {{$t('devices.low_activity')}} ({{$t('routine_analyses.one_point')}})
            </div>
            <div class="col s2">
                 {{$t('devices.average_activity')}} ({{$t('routine_analyses.two_points')}})
            </div>
            <div class="col s2">
                 {{$t('devices.high_activity')}} ({{$t('routine_analyses.three_points')}})
            </div>
            <div class="col s2">
                {{$t('devices.very_high_activity')}} ({{$t('routine_analyses.four_points')}})
            </div>
            <div class="col" :class="{ s1: zone.has_disaster_point, s2: !zone.has_disaster_point }">
                {{$t('devices.critical_point')}}
            </div>
            <div class="col s1" v-if="zone.has_disaster_point">
                {{$t('devices.catastrophal_point')}}
            </div>
        </div>
        <div class="row grey tabel" style="width: 100%; margin-bottom: 15px;">
            <div class="col s2">
                {{$t('devices.no_pest')}}
            </div>
            <div class="col s2 input-field"> 1 szt. &#8212;
                <input v-model="pest_thresold.medium_activity_thresold" type="number" @change="pests_changed(pest_thresold)" style="width: 47px;" :disabled="disabled" min="2"/> szt.
            </div>
            <div class="col s2 input-field">
                {{parse(pest_thresold.medium_activity_thresold, 2) + 1}} &#8212; <input v-model="pest_thresold.high_activity_thresold" type="number" @change="pests_changed(pest_thresold)" style="width: 47px;" :disabled="disabled" min="2"/> szt.
            </div>
            <div class="col s2 input-field">
                {{parse(pest_thresold.high_activity_thresold, 3) + 1}} &#8212; <input v-model="pest_thresold.very_high_activity_thresold" type="number" @change="pests_changed(pest_thresold)" style="width: 47px;" :disabled="disabled" min="2"/> szt.
            </div>
            <div class="col s2 input-field">
                 {{$t('devices.above')}} {{parse(pest_thresold.very_high_activity_thresold, 4)}} szt.
            </div>
            <div class="col s1 input-field inline">
                <input v-model="pest_thresold.critical_point" style="width: 47px;" :disabled="disabled" max="4" min="0" step=".1" type="number" @change="pests_changed(pest_thresold)" />
            </div>
            <div class="col s input-field inline" v-if="zone.has_disaster_point" :class="{ s1: zone.has_disaster_point, s2: !zone.has_disaster_point }">
                <input v-model="pest_thresold.disaster_point" style="width: 47px;" :disabled="disabled" max="4" min="0" step=".1" type="number" @change="pests_changed(pest_thresold)" />
            </div>
            <div class="col s6 right-align" style="line-height: 2">{{$t('devices.critical_disaster')}}:</div>
            <div class="col s6">
                <select v-model="pest_thresold.critical_calculation" :disabled="disabled" @change="pests_changed(pest_thresold)">
                    <option value="max">{{$t('devices.each_device')}}</option>
                    <option value="median">{{$t('devices.median_devices')}}</option>
                    <option value="anyof">{{$t('devices.sum_devices')}}</option>
                    <option value="avg">{{$t('devices.average_devices')}}</option>
                </select></div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
	data: function() {
        return {
            uid: _.uniqueId("removetargetpestquestion")
        }
    },
	props: { pest_thresold: Object, disabled: Boolean, zone: Object, pests: Object },
	methods:{
		pests_changed(pt) {
            if(pt.medium_activity_thresold == ''){
                pt.medium_activity_thresold = 2;
            }
            if(pt.high_activity_thresold == ''){
                pt.high_activity_thresold = 3;
            }
            if(pt.very_high_activity_thresold == ''){
                pt.very_high_activity_thresold = 4;
            }
            if (parseInt(pt.medium_activity_thresold) < 1) {
                pt.medium_activity_thresold = 1;
            }
            if (pt.medium_activity_thresold >= (parseInt(pt.high_activity_thresold) - 1)) {
                pt.high_activity_thresold = parseInt(pt.medium_activity_thresold) + 1;
            }
            if (pt.high_activity_thresold >= (parseInt(pt.very_high_activity_thresold) - 1)) {
                pt.very_high_activity_thresold = parseInt(pt.high_activity_thresold) + 1;
            }
            this.$forceUpdate();
            if(!_.isUndefined(pt.id)) this.$emit('changed');
        },
        parse(value, defaultval){
            if(value == ''){
                return defaultval;
            }else{
                return parseInt(value, 10);
            }
        },
        removeMe(){
             this.$emit('remove');
        }
	},
    computed: {
        pestId: {
            set(value) {
              this.pest_thresold.pest_id = value;
              if(!_.isUndefined(pt.id)) this.$emit('changed');
            },
            get() {
              return this.pest_thresold.pest_id;
            }
        },
        groupId: {
            set(value) {
              this.pest_thresold.group_id = value;
              if(!_.isUndefined(pt.id)) this.$emit('changed');
            },
            get() {
              return this.pest_thresold.group_id;
            }
        }
    }
}

</script>
<style scoped></style>